import { FC } from 'react';

import { DropDownOptions } from 'devextreme-react/cjs/select-box';
import { RequiredRule } from 'devextreme-react/form';

import { AppGroup, AppRow } from 'components/appComponents';
import AppFiledBox from 'components/appComponents/app-field-box';
import { DateBox, NumberBox, SelectBox, Validator } from 'devextreme-react';
import DataSource from 'devextreme/data/data_source';

import { ContractorDriverPumpPriceCreate } from 'bus/contractorDriverPumpPrice/types';

type Props = {
  form: ContractorDriverPumpPriceCreate;
  onChange: (
    name: keyof ContractorDriverPumpPriceCreate,
    value: ContractorDriverPumpPriceCreate[keyof ContractorDriverPumpPriceCreate],
  ) => void;
  storeObject: DataSource;
  type: 'EDIT' | 'CREATE';
};

export const ContractorDriverPumpPriceForm: FC<Props> = ({ form, storeObject, onChange }) => {
  return (
    <AppRow>
      <AppGroup col={12}>
        <AppFiledBox label="Объект" labelTop>
          <SelectBox
            stylingMode="underlined"
            dataSource={storeObject}
            displayExpr="address"
            valueExpr="id"
            value={form.objectId}
            searchEnabled
            onItemClick={(e) => {
              onChange('objectId', e.itemData.id);
            }}
          >
            <DropDownOptions title="Выберите объект" closeOnOutsideClick={true} showTitle={false} />
          </SelectBox>
        </AppFiledBox>

        <AppFiledBox label="Дата начала" labelTop>
          <DateBox
            stylingMode="underlined"
            type="date"
            onValueChange={(e) => {
              onChange('dateBegin', e as string);
            }}
            useMaskBehavior
            dateSerializationFormat="yyyy-MM-ddTHH:mm:ssx"
            value={form.dateBegin}
          >
            <Validator>
              <RequiredRule message="Заполните поле дата начала" />
            </Validator>
          </DateBox>
        </AppFiledBox>

        <AppFiledBox label="Длина насоса" labelTop>
          <NumberBox
            stylingMode="underlined"
            value={form.pumpLen || undefined}
            onValueChange={(e) => {
              onChange('pumpLen', e);
            }}
          >
            <Validator>
              <RequiredRule message="Заполните поле длина насоса" />
            </Validator>
          </NumberBox>
        </AppFiledBox>

        <AppGroup title="Оплата водителям">
          <AppRow>
            <AppFiledBox label="Минимальная цена" labelTop>
              <NumberBox
                stylingMode="underlined"
                value={form.minimalPumpDriverPrice ?? undefined}
                onValueChange={(e) => {
                  onChange('minimalPumpDriverPrice', e || 0);
                }}
              />
            </AppFiledBox>
            <AppFiledBox label="От кубов" labelTop>
              <NumberBox
                stylingMode="underlined"
                value={form.minimalPumpQuantity ?? undefined}
                onValueChange={(e) => {
                  onChange('minimalPumpQuantity', e || 0);
                }}
              />
            </AppFiledBox>
            <AppFiledBox label="Цена за куб" labelTop>
              <NumberBox
                stylingMode="underlined"
                value={form.pumpDriverOverPrice ?? undefined}
                onValueChange={(e) => {
                  onChange('pumpDriverOverPrice', e || 0);
                }}
              />
            </AppFiledBox>
          </AppRow>
        </AppGroup>
      </AppGroup>
    </AppRow>
  );
};
